module.exports = __webpack_public_path__ + "static/img/sample.a7fb9d0f.png";